import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  AppTokenService,
  AuthAccessTokenDetails,
  handleError,
  HttpHeadersPayload,
  HttpRequestMethods,
  IDP_APPS,
  UrlUtil
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { generateUUID } from '@com-delta-idp/mnx-sitewide-shared-utils';
import { from, Observable } from 'rxjs';
import { shareReplay, switchMap } from 'rxjs/operators';
import {
  HTTP_HEADERS,
  TodaysTripEndpointKeys
} from '../../models/constants/today/todays-trip.enums';
import {
  DEFAULT_TIMEOUT,
  SITE_WIDE_TODAYS_TRIP
} from '../../models/constants/todays-trip-constants/todays-trip.constants';
import { TodaysTrip } from '../../models/interfaces/todays-trip/todays-trip.interface';

@Injectable({
  providedIn: 'root'
})
export class TodaysTripService {
  todaysTrip$!: Observable<TodaysTrip>;
  headerInfo: HttpHeadersPayload = {
    'Content-Type': HTTP_HEADERS.FORM_URLENCODED,
    Authorization: ''
  };

  constructor(
    private tokenService: AppTokenService,
    private appConfigService: AppConfigService,
    private http: HttpClient,
    private urlUtil: UrlUtil
  ) {}

  _errorHandler = handleError.bind(this);

  getTodayTrip = (skymilesNumber: string): Observable<TodaysTrip> => {
    if (this.todaysTrip$) {
      return this.todaysTrip$;
    } else {
      this.todaysTrip$ = this.initAwsAPI(skymilesNumber).pipe(shareReplay());
      return this.todaysTrip$;
    }
  };

  initAwsAPI(skymilesNumber: string): Observable<TodaysTrip> {
    return from(this.tokenService.getAppTokenWithParams('', '', true)).pipe(
      switchMap((token: AuthAccessTokenDetails) => {
        this.headerInfo[
          'Authorization'
        ] = `${HTTP_HEADERS.BEARER} ${token.access_token}`;

        const payload = this.urlUtil.toObjQueryString({
          skymilesNbr: skymilesNumber,
          nmbrOfTrips: '1',
          transactionId: `${HTTP_HEADERS.TODAYS_TRIP} ${generateUUID()}`
        });

        return new ApiBuilder<string, TodaysTrip>(
          this.http,
          this.appConfigService
        )
          .app(IDP_APPS.HEADER)
          .endpointKey(TodaysTripEndpointKeys.GET_TODAYS_TRIP_AWS_URL)
          .method(HttpRequestMethods.POST)
          .payload(payload)
          .httpHeaders(this.headerInfo)
          .errorHandler(this._errorHandler)
          .timeOut(DEFAULT_TIMEOUT)
          .library(SITE_WIDE_TODAYS_TRIP)
          .create();
      })
    );
  }
}
